import { render, staticRenderFns } from "./settlement.vue?vue&type=template&id=72ff6396&scoped=true"
import script from "./settlement.vue?vue&type=script&lang=js"
export * from "./settlement.vue?vue&type=script&lang=js"
import style0 from "./settlement.vue?vue&type=style&index=0&id=72ff6396&prod&scoped=true&lang=css"
import style1 from "./settlement.vue?vue&type=style&index=1&id=72ff6396&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ff6396",
  null
  
)

export default component.exports